<template>
	<div class="cd-tabs-container">
		<div class="cd-tabs" v-if="totalTabs > 1">
			<div class="wrapper cd-tabs-wrapper">
				<div v-if="item.content" @click="scrollTo('#tab-desc', {offset: 80})" class="cd-tab-title desc" :class="{'active': activeTab  === 'tab-desc'}"><BaseCmsLabel code="product_descriptions" tag="span" /></div>
				<div v-if="item.element_characteristics" @click="scrollTo('#tab-characteristics', {offset: 80})" class="cd-tab-title characteristics" :class="{'active': activeTab  === 'tab-characteristics'}"><BaseCmsLabel code="product_characteristics" tag="span" /></div>
				<div v-if="itemsAttributes?.length" @click="scrollTo('#tab-specs', {offset: 80})" class="cd-tab-title specs" :class="{'active': activeTab  === 'tab-specs'}"><BaseCmsLabel code="product_specifications" tag="span" /></div>
				<div v-if="item.documents?.length" @click="scrollTo('#tab-docs', {offset: 80})" class="cd-tab-title docs" :class="{'active': activeTab  === 'tab-docs'}"><BaseCmsLabel code="product_download" tag="span" /></div>
				<div v-if="relatedItems?.length" @click="scrollTo('#tab-related', {offset: 80})" class="cd-tab-title related" :class="{'active': activeTab  === 'tab-related'}"><BaseCmsLabel code="product_related" tag="span" /></div>
			</div>
		</div>

		<div class="cd-tabs-content" :class="{'only-related': totalTabs == 1 && relatedItems?.length}">
			<div class="cd-tabs-content-wrapper">
				<div ref="descElement" data-observer-id="tab-desc" id="tab-desc" class="cd-tab-body cd-tab-body-item cd-tab-body-content" :class="{'open': activeContent}" v-if="item.content">
					<div class="cd-tab-body-title desc" @click="openContent()"><BaseCmsLabel code="product_descriptions" tag="span" /></div>
					<div id="itemContent" class="cd-tab-content cms-content" :class="{'open': activeContent}">
						<div v-html="item.content" ref="content"></div>
					</div>
				</div>

				<div ref="characteristicsElement" data-observer-id="tab-characteristics" id="tab-characteristics" class="cd-tab-body cd-tab-body-item cd-tab-body-characteristics" :class="{'open': activeCharacteristics}" v-if="item.element_characteristics">
					<div class="cd-tab-body-title characteristics" @click="activeCharacteristics = !activeCharacteristics"><BaseCmsLabel code="product_characteristics" tag="span" /></div>
					<div id="itemContent" class="cd-tab-content cms-content" :class="{'open': activeCharacteristics}">
						<div v-html="item.element_characteristics" ref="content"></div>
					</div>
				</div>

				<div ref="specsElement" data-observer-id="tab-specs" id="tab-specs" class="cd-tab-body cd-tab-body-item cd-tab-body-specs" :class="{'open': activeSpecs}" v-if="itemsAttributes?.length">
					<div class="page-wrapper cd-tabs-content-wrapper">
						<div class="cd-tab-body-title specs" @click="activeSpecs = !activeSpecs"><BaseCmsLabel code="product_specifications" tag="span" /></div>
						<div id="itemContent" class="cd-tab-content specs-content" :class="{'open': activeSpecs}">
							<div class="spec-items">
								<template v-for="itemAttribute in itemsAttributes" :key="itemAttribute.id">
									<div class="spec-item" v-if="itemAttribute.attribute_code != 'super_prilika'">
										<div class="spec-item-title">{{itemAttribute.attribute_title}}</div>
										<div class="spec-item-content">
											{{ itemAttribute.title }}
											<template v-if="itemAttribute.unit"> {{ itemAttribute.unit }}</template>
										</div>
									</div>
								</template>
							</div>
						</div>
					</div>
				</div>

				<div ref="docsElement" data-observer-id="tab-docs" id="tab-docs" class="cd-tab-body cd-tab-body-item cd-tab-body-docs" :class="{'open': activeDocs}" v-if="item.documents?.length">
					<div class="cd-tab-body-title docs" @click="activeDocs = !activeDocs"><BaseCmsLabel code="product_download" tag="span" /></div>
					<div id="itemContent" class="cd-tab-content cd-tab-docs" :class="{'open': activeDocs}">
						<div class="cd-document" v-for="document in item.documents" :key="document.id">
							<a :href="document.url" target="_blank">{{document.title}} <span v-if="document.size">({{document.size}})</span></a>
						</div>
					</div>
				</div>
				
				<div class="cd-share" v-if="item.content || item.element_characteristics || itemsAttributes?.length || item.documents?.length" :class="{'last': !relatedItems?.length}">
					<CmsShare />
				</div>
			</div>
			
			<div ref="relatedElement" data-observer-id="tab-related" id="tab-related" class="cd-tab-body cd-tab-body-item cd-tab-body-related" v-if="relatedItems?.length">
				<div class="wrapper">
					<div class="cd-tab-body-title related"><BaseCmsLabel code="product_related" tag="span" /></div>
					<div id="itemContent" class="cd-tab-content cd-tab-related" :class="{'open': activeDocs}">
						<BaseUiSwiper 
							:options="{
								slidesPerView: 1,
								slidesPerGroup: 1,
								spaceBetween: 0,
								watchSlidesProgress: true,
								enabled: false,
								breakpoints: {
									980: {
										enabled: true,
										spaceBetween: 12,
										slidesPerView: 4,
										slidesPerGroup: 4,
										watchSlidesProgress: true,
									},
									1250: {
										enabled: true,
										spaceBetween: 24,
										slidesPerView: 4,
										slidesPerGroup: 4,
										watchSlidesProgress: true,
									}
								}
							}"
							class="cd-related-items"
							:class="{'no-slider': relatedItems?.length < 5}"
						>
							<BaseUiSwiperSlide v-for="item in relatedItems" :key="item.id" :class="{'single': relatedItems?.length == 1}">
								<CatalogIndexEntry :item="item" />
							</BaseUiSwiperSlide>
						</BaseUiSwiper>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>
	const props = defineProps(['item', 'relatedItems', 'activeContentTab']);
	const {scrollTo, onMediaQuery, onElementVisibility} = useDom();

	const itemsAttributes = computed(() => {
		if(!props.item.attributes) return [];
		return props.item.attributes.filter(item => item.attribute_code != 'posebne_oznake');
	});

	const totalTabs = computed(() =>{
		let totalTabsCounter = 0;
		if(props.item.content?.length) totalTabsCounter++;
		if(props.item.element_characteristics?.length) totalTabsCounter++;
		if(itemsAttributes?.value?.length) totalTabsCounter++;
		if(props.item.documents?.length) totalTabsCounter++;
		if(props.relatedItems?.length) totalTabsCounter++;

		return totalTabsCounter;
	});

	const {matches: mobileBreakpoint} = onMediaQuery({
		query: '(max-width: 980px)',
	});

	const activeContent = ref(false);
	const activeCharacteristics = ref(false);
	const activeSpecs = ref(false);
	const activeDocs = ref(false);
	const activeComments = ref(false);
	const activeRelated = ref(false);

	const activate = () => {
		activeContent.value = true
	}
	defineExpose({
		activate
	})

	function openContent(){
		activeContent.value = !activeContent.value
	}

	// Auto select content tab
	const activeTab = ref(null);
	const descElement  = ref(null);
	const specsElement = ref(null);
	const docsElement = ref(null);
	const characteristicsElement = ref(null);
	const relatedElement = ref(null);
	onElementVisibility({
		target: [descElement, characteristicsElement, docsElement, specsElement, relatedElement],
		options: { rootMargin: "-50px 0px 0px 0px", treshold: 0 },
		callback: ({ visibleElements }) => {
			activeTab.value = visibleElements?.length ? visibleElements[0] : null; // Element observer id is set as active tab
		}
	});

	onMounted(() => {
		if(mobileBreakpoint.value == true){
			activeContent.value = true
		}
	});
</script>


<style lang="less" scoped>
	.cd-tabs-container{position: relative; display: block; background: var(--lightGray);}
	.cd-tabs{
		position: sticky; top: -1px; width: 100%; background: #fff; z-index: 3; border-top: 1px solid var(--gray); border-bottom: 1px solid var(--gray);
		@media (max-width: @m){display: none!important;}	
	}
	.cd-tabs-wrapper{display: flex; justify-content: center;}
	.cd-tab-title{
		position: relative; display: flex; align-items: center; justify-content: center; font-size: 14px; line-height: 1.2; font-weight: 700; height: 64px; padding: 0 36px; border-left: 1px solid var(--gray); border-right: 1px solid var(--gray); cursor: pointer; margin-left: -1px; color: var(--blue);
		&:first-child{margin-left: 0;}
		&.active{
			color: var(--textColor);
			&:after{opacity: 1;}
		}
		&:before{.icon-info(); font: 23px/1 var(--fonti); color: var(--blue); margin-right: 10px;}
		&:after{.pseudo(auto,3px); background: var(--blue2); bottom: 0; left: 36px; right: 36px; opacity: 0; .transition(opacity);}
		span{padding-top: 5px;}
		&.characteristics:before{.icon-control(); font-size: 20px;}
		&.specs:before{.icon-settings(); font-size: 26px;}
		&.docs:before{.icon-document(); font-size: 24px;}
		&.related:before{.icon-link2();}
		@media (min-width: @h){
			&:hover:after{opacity: 1;}
		}
		@media (max-width: @l){padding: 0 30px;}
		@media (max-width: @t){padding: 0 15px;}
	}
	.cd-tabs-content{
		padding: 40px 0 0;
		&.only-related{
			padding-top: 0;
			.cd-tab-body-related{margin-top: 0; border-top: 0;}
		}
		@media (max-width: @m){padding: 0;}	
	}
	.cd-tabs-content-wrapper{
		display: block; width: 760px; margin: 0 auto;
		@media (max-width: @m){width: 100%; display: flex; flex-flow: column; gap: 1;}	
	}
	.cd-tab-body{
		display: block; margin-bottom: 48px;
		&:last-child{margin-bottom: 0;}
		@media (max-width: @m){
			margin-bottom: 0; border-top: 1px solid var(--gray); border-bottom: 1px solid var(--gray); margin-top: -1px;
			&.open{
				border-bottom: 0;
				.cd-tab-body-title{
					padding-bottom: 16px;
					&:after{.rotate(-90deg); right: 12px;}
				}
				.cd-tab-content{display: flex;}
			}	
		}
	}
	.cd-tab-body-title{
		display: block; font-size: 26px; line-height: 1.46; margin-bottom: 11px;
		@media (max-width: @m){
			font-size: 14px; margin-bottom: 0; padding: 17px 52px; font-weight: 700; color: var(--blue); position: relative;
			&:before{.pseudo(26px,26px); display: flex; align-items: center; justify-content: center; left: 16px; top: 13px; .icon-info(); font: 24px/1 var(--fonti); color: var(--blue);}
			&:after{.pseudo(11px,11px); .icon-arrow-right(); font: 11px/1 var(--fonti); color: var(--blue); right: 16px; top: 22px; display: flex; align-items: center; justify-content: center; .rotate(90deg);}
			&.characteristics:before{.icon-control(); font-size: 20px;}
			&.specs:before{.icon-settings(); font-size: 26px;}
			&.docs:before{.icon-document(); font-size: 24px;}
			&.related{color: var(--textColor); font-weight: normal; line-height: 24px;}
		}	
	}
	.cd-tab-content{
		:deep(iframe){display: block; width: 100%; height: auto; aspect-ratio: 16/9;}
		:deep(p:last-child){padding-bottom: 0;}
		:deep(ul:last-child){margin-bottom: 0;}
		@media (max-width: @m){padding: 0 16px 20px; display: none;}
	}

	.spec-items{
		@media (max-width: @m){width: 100%;}
	}
	.spec-item{
		position: relative; display: flex; align-items: center; font-size: 16px; line-height: 1.6; justify-content: space-between; padding: 13px 24px;
		&:nth-child(odd){background: #fff; border-radius: 6px;}
		@media (max-width: @m){font-size: 14px; padding: 13px 12px;}	
	}
	.spec-item-title{
		font-size: 14px; font-weight: 700; width: 40%;
		@media (max-width: @m){font-size: 12px;}	
	}
	.spec-item-content{width: 60%; text-align: right;}

	.cd-tab-docs{
		position: relative; display: flex; flex-flow: column; width: 100%; gap: 10px;
		@media (max-width: @m){display: none;}	
	}
	.cd-document{
		a{
			position: relative; display: flex; align-items: center; background: #fff; border: 1px solid var(--gray); border-radius: 6px; padding: 19px 62px 16px; font-size: 14px; line-height: 1.4; font-weight: 700; color: var(--blue); text-decoration: none; transition: border-color 0.3s, background 0.3s;
			&:before{.pseudo(20px,26px); background: url('/assets/images/pdf.png') center no-repeat; background-size: cover; top: 15px; left: 24px;}
			&:after{.pseudo(24px,24px); .icon-download(); font: 24px/1 var(--fonti); color: var(--blue); top: 16px; right: 24px; border-radius: 50%;}
			@media (min-width: @h){
				&:hover{
					border-color: var(--blue);
					&:after{.icon-download-full();}
				}
			}
		}
		span{color: var(--textColor); font-weight: normal; margin-left: 3px;}
		@media (max-width: @m){
			a{
				font-size: 12px; padding: 17px 46px 12px;
				&:before{width: 18px; height: 22px; top: 13px; left: 16px;}	
				&:after{width: 20px; height: 20px; font-size: 20px; top: 12px; right: 16px;}
			}
		}
	}

	.cd-share{
		&.last{padding-bottom: 80px;}
		:deep(.share){padding-top: 0;}
		:deep(.ss-item:not(:hover)){background: #fff;}
		@media (max-width: @m){
			padding: 24px 16px 0;
			&.last{padding-bottom: 24px;}
		}
	}

	.cd-tab-body-related{
		position: relative; display: block; margin-top: 48px; padding: 52px 0 80px; border-top: 1px solid var(--gray); overflow: hidden;
		@media (max-width: @m){padding-top: 32px; padding-bottom: 40px; margin-top: 0; border-top: 0;}	
	}
	.cd-tab-body-title.related{
		display: block; text-align: center; font-size: 30px; margin-bottom: 20px;
		@media (max-width: @m){
			padding: 0; text-align: left; font-size: 22px; margin-bottom: 17px;
			&:before, &:after{display: none!important;}
		}	
	}
	.cd-tab-related{
		@media (max-width: @m){
			display: flex; width: calc(~"100% - -32px"); margin-left: -16px; padding-bottom: 0;
			.swiper-container{position: relative; display: block; width: 100%;}	
		}
	}
	:deep(.swiper){
		overflow: visible;
		.swiper-slide:not(.swiper-slide-visible){opacity: 0; pointer-events: none;}
		@media (max-width: @m){
			margin: 0 -16px; display: flex;
			.swiper-wrapper{
				padding: 0 16px; overflow-x: auto; box-sizing: border-box; gap: 16px; width: 100%; height: auto;
				&::-webkit-scrollbar {-webkit-appearance: none; height: 0;}
				&::-webkit-scrollbar-thumb {background-color: transparent;}	
			}
			.swiper-slide{
				display: flex; flex-grow: 0; flex-shrink: 0; width: 230px!important;	
				&.single{width: 100%!important;}
			}
			.swiper-slide:not(.swiper-slide-visible){opacity: 1; pointer-events: inherit;}
		}
	}
	:deep(.swiper-navigation){
		@media (max-width: @m){display: none!important;}
	}
	:deep(.swiper-button-disabled){display: none;}
	:deep(.cp){
		width: 100%;
		@media (max-width: @m){margin: 0; border-radius: 10px; border: none; box-shadow: 0 10px 60px rgba(0,0,0,0.04);}	
	}
	@media (max-width: @m){
		:deep(.cp-cnt), :deep(.cp-cnt-main){align-items: center;}
		:deep(.cp-title){text-align: center;}
	}
	.cd-related-items{
		&.no-slider{
			:deep(.swiper-wrapper){justify-content: center;}
			@media (max-width: @m){
				:deep(.swiper-wrapper){justify-content: inherit;}
			}
		}
		@media (max-width: @m){
			:deep(.cp-category-title){text-align: center;}
			:deep(.cp-top){align-items: center;}
			:deep(.cp-special-attribute){left: auto;}
		}
	}
</style>